<template>
  <div>
    <div class="is-marginless match-box">
      <h1 class="title is-size-4">Match {{ match.Match }} 
        
        <span class="incomplete">
          <i class="fas fa-exclamation"></i> <span class="incomplete-text">incomplete</span>
        </span>

      </h1>
      <div class="winner-container">
        <ul>
            <li class="plyr"><i class="fas fa-user"></i> {{ (match.player1name != null ? match.player1name : getPlayerName(match.player1)) }}</li>
            <li class="plyr"><i class="fas fa-user"></i> {{ (match.player2name != null ? match.player2name : getPlayerName(match.player2)) }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'match'
  ],
    components : {
  },
  methods:{
    getPlayerName: function(playerId) {
      if (playerId != null && playerId != "" && playerId === "bye") {
        return "bye";
      } else if (playerId != null && (""+playerId).substring(0,1) == "R") {
        var rnd = playerId.substring(1,2);
        var mtch = playerId.substring(3,4);

        var rndFriendly = "";
        var mtchFriendly = "";

        var rounds = this.$parent.$parent.gameData.rounds;
        if (rounds) {
          for (var i = 0; i < rounds.length; i++) {
            if (rounds[i].type == "Finals") {
              if (rounds[i].originalRoundId == rnd) {
                for (var x = 0; x < rounds[i].matches.length; x++) {
                  if (rounds[i].matches[x].originalMatchId == mtch) {
                    rndFriendly = (i+1);
                    mtchFriendly = (x+1);
                  }
                }
              }
            }
          }
          for (var i = 0; i < rounds.length; i++) {
            if (rounds[i].type == "Finals") {
              if (rounds[i].originalRoundId == rnd) {
                for (var x = 0; x < rounds[i].matches.length; x++) {
                  if (rounds[i].matches[x].originalMatchId == mtch) {
                    if (rounds[i].matches[x].winnerId) {
                      var winnerId = rounds[i].matches[x].winnerId;
                      var players = this.$parent.$parent.gameData.finalPlayers;
                      for (var z = 0; z < players.length; z++) {
                        if (players[z].id == winnerId) {
                          return "Winner of Finals Round " + rndFriendly + " Match " + mtchFriendly + ": " + players[z].name;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        //fail
        return "Winner of Finals Round " + rndFriendly + " Match " + mtchFriendly;
      } else {
        //console.log("getPlayerName: " + playerId);
        //console.log("finalPlayers", this.$parent.$parent.gameData.finalPlayers);
        if (isNaN(playerId)) return "";
        var position = playerId - 1;
        //console.log("position", position);
        return this.$parent.$parent.gameData.finalPlayers[position].name;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .incomplete {
    color: rgb(255, 255, 125) !important;
    padding-left: 30px;
  }
  .incomplete-text {
    font-size: 0.50m;
    font-weight: normal;
  }
  .match-box {
    border: solid yellow 1px;
    border-radius: 5px !important;
    margin-bottom: 10px !important;
  }
  .title {
    border-bottom: solid yellow 1px;
    font-family: '28 Days Later';
    padding-left: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
    color: green !important;
    cursor: pointer;
    margin-bottom: 0px;
    background-color: rgb(36, 36, 39);
  }
  .winner-container {
    padding: 20px;
    background-color: rgb(36, 36, 39);
  }
  .plyr {
    color: yellow;
  }
</style>